module.exports = __webpack_public_path__ + "static/media/steam-square.c2899968.svg";